import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { User } from '../models/user.model';
import { ApiRequestsService } from './api-requests.service';
import { AuthService } from './auth.service';
import { NotificationsService } from './notifications.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  user: User;
  userSubscription: Subscription;

  constructor(private apiRequestsService: ApiRequestsService,
              private authService: AuthService,
              private notificationsService: NotificationsService,
              private sanitizer: DomSanitizer) {
    this.userSubscription = this.authService.userSubject.subscribe(
      (user: User) => {
        const userChange: boolean = (this.user==undefined || user==undefined || this.user.email != user.email);
        this.user = user;
        if (userChange) {
          this.loadPicture();
        }
      }
    );
    this.authService.emitUser();
  }

  setUserPicture(picture_b64: string, content_type: string) {
    if (content_type != undefined && picture_b64 != undefined) {
      this.user.picture_b64 = this.sanitizer.bypassSecurityTrustResourceUrl(
        `data:${content_type};base64, ${picture_b64}`);
      this.authService.emitUser();
    }
  }

  async updatePicture(file: File) {
    if (!this.user) {
      return;
    }
    try {
      const pictureData: FormData = new FormData();
      pictureData.append('picture', file);

      // Update user infos
      const data = await this.apiRequestsService.post('user-picture', pictureData);

      this.setUserPicture(data['picture_b64'], data['content_type']);

      this.notificationsService.notify('user/update-picture-ok');
    }
    catch(e) {
      this.notificationsService.notify('user/update-picture-ko');
    }
  }

  async loadPicture() {
    if (!this.user) {
      return;
    }
    try {
      // Update user infos
      const data = await this.apiRequestsService.get('user-picture');

      this.setUserPicture(data['picture_b64'], data['content_type']);
    }
    catch(e) {
      this.notificationsService.notify('user/load-picture-ko');
    }
  }
}
